import { render, staticRenderFns } from "./CDropdown.vue?vue&type=template&id=4ef8bd1b&scoped=true"
import script from "./CDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./CDropdown.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CDropdown.vue?vue&type=style&index=0&id=4ef8bd1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef8bd1b",
  null
  
)

export default component.exports